import { service } from '@ember/service'
import RSVP from 'rsvp'
import Route from '@ember/routing/route'
import type StudentEventsService from 'district-ui-client/services/student-events'
import type UiScopeRoute from 'district-ui-client/reporting/ui-scope/route'
import { toStatsScope, type StatsScope } from 'district-ui-client/utils/student-events/stats-scope'
import type { NormalizedInterval } from 'date-fns'
import type LessonInfoService from 'district-ui-client/services/lesson-info'
import { Precinct } from 'district-ui-client/domain/precinct'

export default class RexSpellingProgressAveragesRoute extends Route {
  @service studentEvents!: StudentEventsService

  @service lessonInfo!: LessonInfoService

  async model() {
    const { uiScope, period, scopedData } = this.modelFor('reporting.ui-scope') as ModelFor<UiScopeRoute>

    const product: LegacyProductRex = 'rex'
    const precinct: LegacyPrecinctSpelling = 'spelling'
    const statsScope = toStatsScope(uiScope)

    await this.lessonInfo.loadLessonInfoFor([Precinct.REX_SPELLING])
    const stats = await this.makeStatsRequest(product, precinct, statsScope, period)

    return {
      product,
      uiScope,
      period,
      scopedData,
      precinct,
      ...stats,
    }
  }

  makeStatsRequest = (
    product: LegacyProductRex,
    precinct: LegacyPrecinctSpelling,
    scope: StatsScope,
    period: NormalizedInterval,
  ) => {
    const { studentEvents } = this

    return RSVP.hash({
      spellingProgressAverages: studentEvents.courseProgressAverages(product, precinct, scope, period),
    })
  }
}
